import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidatePortfolioOnForbidden } from "web_myplann/Api/Portfolio/invalidatePortfolioOnForbidden";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPropertyArtDetailResponseDTO,
	type ClientPropertyArtEditRequestDTO,
	patchPropertyArtIdV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePatchPropertyArtMutation = (id: number) => {
	const queryClient = useQueryClient();

	return useMutation<
		ClientPropertyArtDetailResponseDTO,
		Error,
		Partial<ClientPropertyArtEditRequestDTO>
	>({
		mutationFn: processResponse((requestContract) =>
			patchPropertyArtIdV2(requestContract, id),
		),
		onError: (error) => invalidatePortfolioOnForbidden(queryClient, error),
		onSuccess: (data) => {
			queryClient.invalidateQueries({ queryKey: PortfolioKeys.propertyList() });
			queryClient.setQueryData(PortfolioKeys.propertyDetail(id), data);
		},
	});
};
